import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect, useRef, useState } from 'react';
import Footer from '../components/footer/Footer';
import { s } from '../search/filter/Filter.styles';
import RegionService from '../../service/Region';
import {
  BidStatusList,
  CommercialBankData,
  CourtList,
  FilterType,
  InternetBankData,
  ItemStatusList,
  LocalBankData,
  NplHolderList,
  ProgressStatusList,
  PTypeItemStatusList,
  PTypeProgressStatusList,
  Region,
  RegionProps,
  SidoList,
  SpecialBankData,
  SpecialConditionList,
  UseAreaList,
  SecuritiesCompanyData,
  InsuranceCompanyData,
  SavingsBankData,
  MutualFinanceData,
  CreditSpecializedCompanyData,
  TrustCompanyData,
  LoanCompanyData,
  SecuritizationSpecializedCompanyData,
  OnlineInnvestmentFinancialBusiness,
  NonghyupData,
  KFCCData,
  SuhyupData,
} from '../search/FilterData';
import LoanInfoService from '../../service/LoanInfo';
import Select from 'react-select';
import ItemStatusOption from '../search/filter/ItemStatusOption';
import PItemStatusOption from '../search/filter/PItemStatusOption';
import UnitSwitch from '../components/unitSwitch/UnitSwitch';
import UseArea from '../search/filter/UseArea';
import SpecailCondition from '../search/filter/SpecialCondition';
import List from '../components/list/List';
import AddInterestItemModal from '../components/modal/AddInterestItem';
import HoldingCompany from '../search/filter/HoldingCompany';
import ScrollToTopButton from '../components/ScrollToTopButton';
import PageDescription from '../components/description/Description';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
type SortOption = { value: string; label: string };

const totalHoldinsCompany = [
  ...CommercialBankData,
  ...InternetBankData,
  ...LocalBankData,
  ...SpecialBankData,
  ...SecuritiesCompanyData,
  ...InsuranceCompanyData,
  ...SavingsBankData,
  ...MutualFinanceData,
  ...CreditSpecializedCompanyData,
  ...TrustCompanyData,
  ...LoanCompanyData,
  ...SecuritizationSpecializedCompanyData,
  ...OnlineInnvestmentFinancialBusiness,
  ...NonghyupData,
  ...KFCCData,
  ...SuhyupData,
];

const NplSearch = () => {
  const { modalDispatch } = useModal();

  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    regionOrCourt: 'r',
    region: [] as Region[],
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidno: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });
  const [unit, setUnit] = useState('평');
  const [unit1, setUnit1] = useState('평');
  const [sido, setSido] = useState('');
  const [sigungu, setSigungu] = useState('');
  const [emd, setEmd] = useState('');
  const [sigunguList, setSigunguList] = useState<RegionProps[] | undefined>([]);
  const [emdList, setEmdList] = useState<RegionProps[] | undefined>([]);
  const [currentRegion, setCurrentRegion] = useState<Region>({
    sido: '',
    sigungu: '',
    emd: '',
  });
  const [isMultiple, setIsMultiple] = useState(false);
  const [showAllItemType, setShowAllItemType] = useState(false);
  const [showSpecialCondition, setShowSpecialCondition] = useState(false);
  const [showHoldingCompany, setShowHoldingCompany] = useState(false);
  const [showUsageArea, setShowUsageArea] = useState(false);
  const [isMinAppraiseFocus, setIsMinAppraiseFocus] = useState(false);
  const [isMaxAppraiseFocus, setIsMaxAppraiseFocus] = useState(false);
  const [isMinPriceMinFocus, setIsMinPriceMinFocus] = useState(false);
  const [isMinPriceMaxFocus, setIsMinPriceMaxFocus] = useState(false);
  const [isMinBuildingAreaFocus, setIsMinBuildingAreaFocus] = useState(false);
  const [isMaxBuildingAreaFocus, setIsMaxBuildingAreaFocus] = useState(false);
  const [isMinLandAreaFocus, setIsMinLandAreaFocus] = useState(false);
  const [isMaxLandAreaFocus, setIsMaxLandAreaFocus] = useState(false);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [loading, setLoading] = useState(false);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const param = new URLSearchParams(window.location.search);
  const condition = param.get('specialCondition');
  const date = param.get('date');
  const status =
    param.get('status') === 'a'
      ? '전체'
      : param.get('status') === 'n'
        ? '신건'
        : param.get('status') === 's'
          ? '매각/매각허가'
          : '진행';
  const radioType = param.get('radioType');
  const court = param.get('court');

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };

  const getRegion = async (code: string) => {
    try {
      const res = await RegionService.list(code);
      return res.data as RegionProps[];
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (sido !== '') {
      getRegion(sido).then((res) => setSigunguList(res));
    }
  }, [sido]);

  useEffect(() => {
    if (sigungu !== '') {
      getRegion(sigungu).then((res) => setEmdList(res));
    }
  }, [sigungu]);

  const sidoOptions = SidoList.map((sido) => ({
    value: sido.code,
    label: sido.region,
  }));
  const sigunguOptions = (sigunguList ?? []).map((sigungu) => ({
    value: sigungu.code,
    label: sigungu.region,
  }));
  const emdOptions = (emdList ?? [])
    .filter((emd) => emd.region !== '전체')
    .map((emd) => ({
      value: emd.code,
      label: emd.region,
    }));

  useEffect(() => {
    if (!isMultiple) {
      setFilters({
        ...filters,
        region: [currentRegion],
      });
    }
  }, [currentRegion, isMultiple]);

  const handleAddRegion = () => {
    setIsMultiple(true);
    const lastRegion = filters.region[filters.region.length - 1];

    if (
      !lastRegion ||
      lastRegion.sido !== currentRegion.sido ||
      lastRegion.sigungu !== currentRegion.sigungu ||
      lastRegion.emd !== currentRegion.emd
    ) {
      setFilters((prevFilters: FilterType) => ({
        ...prevFilters,
        region: [...prevFilters.region, currentRegion],
      }));
    }
  };

  const handlePriceChange = (
    e: any,
    category: 'appraisalPrice' | 'minPrice' | 'buildingArea' | 'landArea',
    type: 'min' | 'max',
  ) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setFilters((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [type]: value,
      },
    }));
  };

  const handleFocus = (event: any) => {
    event.target.showPicker();
  };

  const prevFiltersRef = useRef(filters);

  const isOnlyProgressStatusChangedToAll = () => {
    const prev = prevFiltersRef.current;

    if (filters.progressStatus !== '전체') return false;
    const { progressStatus: _, region, regionOrCourt, ...rest } = filters;
    const {
      progressStatus: __,
      region: prevRegion,
      regionOrCourt: ___,
      ...prevRest
    } = prev;

    const same = JSON.stringify(rest) === JSON.stringify(prevRest);
    if (!same) {
      console.log(JSON.stringify(rest));
      console.log(JSON.stringify(prevRest));
    }
    const isRegionChange =
      region.length === 0 ||
      (region.length === 1 &&
        region[0].sido === '' &&
        region[0].sigungu === '' &&
        region[0].emd === '');

    return same && isRegionChange;
  };

  const handleReSet = () => {
    setFilters({
      type: 'a',
      regionOrCourt: 'r',
      region: [] as Region[],
      court: '',
      itemStatus: [],
      multiItemStatus: [],
      appraisalPrice: { min: '', max: '' },
      minPrice: { min: '', max: '' },
      saleDate: { start: '', end: '' },
      approvalDate: { start: '', end: '' },
      buildingArea: { min: '', max: '' },
      landArea: { min: '', max: '' },
      bidno: '',
      progressStatus: '진행',
      useArea: [],
      multiUseArea: [],
      specialConditionViewOption: 'o',
      specialItemCondition: [],
      multiSpecialItemCondition: [],
      holdingCompany: [],
      multiHoldingCompany: [],
    });
    setCurrentRegion({
      sido: '',
      sigungu: '',
      emd: '',
    });
    setShowAllItemType(false);
    setShowSpecialCondition(false);
    setShowHoldingCompany(false);
    setShowUsageArea(false);
    setIsMultiple(false);
  };

  const ChangeStatusValue = (status: string) => {
    const newValue = BidStatusList.find((item) => item.label === status)?.value;
    return newValue ?? '';
  };

  const getList = async (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters: FilterType,
  ) => {
    try {
      if (!isLogin()) return;
      setLoading(true);
      const res = await LoanInfoService.list(
        filters.type, // 경매  혹은 공매
        filters.regionOrCourt, //  법원 혹은 지역
        filters.court,
        filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        '', // 세부 주소 혹은 건물명
        '', // 사건번호
        '', // 키워드
        filters.itemStatus.join(',') === ''
          ? filters.multiItemStatus.join(',')
          : filters.itemStatus.join(','),
        Number(filters.appraisalPrice.min),
        Number(filters.appraisalPrice.max),
        Number(filters.minPrice.min),
        Number(filters.minPrice.max),
        Number(filters.buildingArea.min),
        Number(filters.buildingArea.max),
        Number(filters.landArea.min),
        Number(filters.landArea.max),
        filters.saleDate.start,
        filters.saleDate.end,
        filters.approvalDate.start,
        filters.approvalDate.end,
        ChangeStatusValue(filters.bidno),
        filters.progressStatus,
        filters.specialConditionViewOption,
        filters.specialItemCondition.join(',') === ''
          ? filters.multiSpecialItemCondition.join(',')
          : filters.specialItemCondition.join(','),
        filters.useArea.join(',') === ''
          ? filters.multiUseArea.join(',')
          : filters.useArea.join(','),
        '',
        'Y',
        filteredValues(
          filters.holdingCompany.join(',') === ''
            ? filters.multiHoldingCompany
            : filters.holdingCompany,
        ),
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(res.data.totalNumber);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (condition || date || status || radioType || court) {
      const initialFilters = {
        ...filters,
        specialItemCondition: condition ? [condition] : [],
        progressStatus: status,
        saleDate: { start: date || '', end: date || '' },
        regionOrCourt: radioType === 'r' ? 'r' : 'c',
        court: court || '',
      };
      getList(0, sort, initialFilters);
      setFilters(initialFilters);
    } else return;
  }, []);

  useEffect(() => {
    if (offset === 0 && data.length === 0) return;
    getList(offset, sort, filters);
  }, [offset]);

  const prevSort = useRef(sort);
  useEffect(() => {
    if (prevSort.current === sort) return; // sort 값이 변경되지 않았으면 실행 안 함
    if (data.length === 0) return;
    setOffset(0);
    getList(0, sort, filters);
    prevSort.current = sort; // 이전 sort 값 업데이트
  }, [sort]);

  const renderRegionOrCourt = () => {
    if (filters.regionOrCourt === 'r') {
      return (
        <s.FilterRow>
          <s.FilterLabel>지역</s.FilterLabel>
          <s.FilterRowContent>
            <div style={{ flex: 1 }}>
              <Select
                options={sidoOptions}
                value={
                  sidoOptions.find(
                    (option) => option.label === currentRegion.sido,
                  ) || null
                }
                styles={customStyles}
                placeholder="시/도"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSido(selectedOption.value);
                    setSigungu('');
                    setEmd('');
                    setCurrentRegion({
                      sido: selectedOption.label,
                      sigungu: '',
                      emd: '',
                    });
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Select
                options={sigunguOptions}
                value={
                  sigunguOptions.find(
                    (option) => option.label === currentRegion.sigungu,
                  ) || null
                }
                styles={customStyles}
                placeholder="시/군/구"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSigungu(selectedOption.value);
                    setEmd('');
                    setCurrentRegion({
                      ...currentRegion,
                      sigungu: selectedOption.label,
                      emd: '',
                    });
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Select
                options={emdOptions}
                value={
                  emdOptions.find(
                    (option) => option.label === currentRegion.emd,
                  ) || null
                }
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...customStyles.control(provided),
                  }),
                }}
                placeholder="읍/면/동"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setEmd(selectedOption.value);
                    setCurrentRegion({
                      ...currentRegion,
                      emd: selectedOption.label,
                    });
                  }
                }}
              />
            </div>
            <s.PlusButton onClick={handleAddRegion}>
              <img src="/assets/images/icon/plus-white.svg" alt="" />
            </s.PlusButton>
          </s.FilterRowContent>
          {filters.region.length > 0 && filters.region[0].sido !== '' && (
            <s.SelectedRegionBox>
              {filters.region.map((region, index) => (
                <s.RegionTag key={index}>
                  <div>
                    {region.sido} {region.sigungu ? region.sigungu : ' 전체'}{' '}
                    {region.emd && region.sigungu ? region.emd : ' 전체'}
                  </div>
                  <img
                    src="/assets/images/close/close-gray.svg"
                    alt=""
                    onClick={() => {
                      setFilters({
                        ...filters,
                        region: filters.region.filter((_, i) => i !== index),
                      });
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                </s.RegionTag>
              ))}
            </s.SelectedRegionBox>
          )}
        </s.FilterRow>
      );
    } else {
      return (
        <s.FilterRow>
          <s.FilterLabel>법원</s.FilterLabel>
          <Select
            options={CourtList}
            styles={{
              ...customStyles,
              control: (provided: any) => ({
                ...customStyles.control(provided),
              }),
            }}
            value={
              filters.court === ''
                ? null
                : {
                    label: filters.court,
                    value: filters.court,
                  }
            }
            placeholder="법원 선택"
            onChange={(selectedOption) => {
              if (selectedOption) {
                setFilters({ ...filters, court: selectedOption.value });
              }
            }}
          />
        </s.FilterRow>
      );
    }
  };

  return (
    <Container>
      <ScrollToTopButton />
      <PageTop text="NPL 검색" />
      <s.Container>
        <PageDescription
          only="24px 16px"
          desc1="수백만 건 경매 물건 중, 진짜 기회는 금융기관 부실 채권 안에 있습니다."
          desc2="사건번호부터 감정가, 매각일, 유찰횟수까지 원하는 조건으로 빠르게 검색하고, 전략적 부실채권 투자 기회를 선점하세요."
        />
        <s.FilterBox>
          <s.FilterOptionBox>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <s.FilterRow>
                <s.FilterLabel>물건분류</s.FilterLabel>
                <s.TabButtonBox>
                  <s.TabButton
                    isActive={filters.type === 'a'}
                    disabled
                    // onClick={() => {
                    //   setFilters({ ...filters, type: 'a' });
                    // }}
                  >
                    경매
                  </s.TabButton>
                  {/* <s.TabButton
                    isActive={filters.type === 'p'}
                    disabled
                    style={{
                      color: 'rgba(55, 56, 60, 0.16)',
                    }}
                    // onClick={() => {
                    //   setFilters({ ...filters, type: 'p', regionOrCourt: 'r' });
                    // }}
                  >
                    공매
                  </s.TabButton> */}
                </s.TabButtonBox>
              </s.FilterRow>
              <s.FilterRow>
                <s.FilterLabel>지역/법원</s.FilterLabel>
                <s.TabButtonBox>
                  <s.TabButton
                    isActive={filters.regionOrCourt === 'r'}
                    disabled={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, regionOrCourt: 'r' });
                    }}
                    style={{
                      border:
                        filters.type === 'p'
                          ? '1px solid rgba(55, 56, 60, 0.16)'
                          : '',
                      color:
                        filters.type === 'p' ? 'rgba(55, 56, 60, 0.16)' : '',
                    }}
                  >
                    지역
                  </s.TabButton>
                  <s.TabButton
                    isActive={filters.regionOrCourt === 'c'}
                    disabled={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, regionOrCourt: 'c' });
                    }}
                    style={{
                      color:
                        filters.type === 'p' ? 'rgba(55, 56, 60, 0.16)' : '',
                    }}
                  >
                    법원
                  </s.TabButton>
                </s.TabButtonBox>
              </s.FilterRow>
            </div>
            {renderRegionOrCourt()}
            <s.FilterRow>
              <s.FilterLabel>물건종류</s.FilterLabel>
              <s.FilterRowContent>
                <div style={{ flex: 1 }}>
                  <Select
                    options={
                      filters.type === 'p'
                        ? PTypeItemStatusList
                        : ItemStatusList
                    }
                    styles={{
                      ...customStyles,
                      control: (provided: any) => ({
                        ...customStyles.control(provided),
                      }),
                    }}
                    placeholder="선택"
                    value={
                      filters.itemStatus.length > 0
                        ? {
                            label: filters.itemStatus[0],
                            value: filters.itemStatus[0],
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFilters({
                          ...filters,
                          multiItemStatus: [],
                          itemStatus: [selectedOption.label],
                        });
                      }
                    }}
                    isDisabled={showAllItemType}
                  />
                </div>
                {showAllItemType ? (
                  <s.PlusButton
                    style={{ backgroundColor: '#0052BD' }}
                    onClick={() => setShowAllItemType(false)}
                  >
                    <span>단일선택</span>
                    <img src="/assets/images/close/close-white.svg" alt="" />
                  </s.PlusButton>
                ) : (
                  <s.PlusButton onClick={() => setShowAllItemType(true)}>
                    <span>복수선택</span>
                    <img src="/assets/images/icon/plus-white.svg" alt="" />
                  </s.PlusButton>
                )}
              </s.FilterRowContent>
              {showAllItemType && filters.type === 'a' && (
                <ItemStatusOption filters={filters} setFilters={setFilters} />
              )}
              {showAllItemType && filters.type === 'p' && (
                <PItemStatusOption filters={filters} setFilters={setFilters} />
              )}
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>감정가격</s.FilterLabel>
              <s.FilterRowContent>
                <div style={{ flex: 1 }}>
                  <s.MinMaxText>최소</s.MinMaxText>
                  <s.FilterInputWrapper>
                    <s.FilterInput
                      style={{ textAlign: 'right' }}
                      value={
                        isMinAppraiseFocus
                          ? filters.appraisalPrice.min
                          : filters.appraisalPrice.min === ''
                            ? ''
                            : Number(
                                filters.appraisalPrice.min,
                              ).toLocaleString()
                      }
                      onFocus={() => setIsMinAppraiseFocus(true)}
                      onBlur={() => setIsMinAppraiseFocus(false)}
                      onChange={(e) =>
                        handlePriceChange(e, 'appraisalPrice', 'min')
                      }
                    />
                    <span style={{ whiteSpace: 'nowrap' }}>만원</span>
                  </s.FilterInputWrapper>
                </div>

                <span style={{ padding: '26px 4px 0' }}>~</span>
                <div style={{ flex: 1 }}>
                  <s.MinMaxText>최대</s.MinMaxText>
                  <s.FilterInputWrapper>
                    <s.FilterInput
                      style={{ textAlign: 'right' }}
                      value={
                        isMaxAppraiseFocus
                          ? filters.appraisalPrice.max
                          : filters.appraisalPrice.max === ''
                            ? ''
                            : Number(
                                filters.appraisalPrice.max,
                              ).toLocaleString()
                      }
                      onFocus={() => setIsMaxAppraiseFocus(true)}
                      onBlur={() => setIsMaxAppraiseFocus(false)}
                      onChange={(e) =>
                        handlePriceChange(e, 'appraisalPrice', 'max')
                      }
                    />
                    <span style={{ whiteSpace: 'nowrap' }}>만원</span>
                  </s.FilterInputWrapper>
                </div>
              </s.FilterRowContent>
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>최저가격</s.FilterLabel>
              <s.FilterRowContent>
                <div style={{ flex: 1 }}>
                  <s.MinMaxText>최소</s.MinMaxText>
                  <s.FilterInputWrapper>
                    <s.FilterInput
                      style={{ textAlign: 'right' }}
                      value={
                        isMinPriceMinFocus
                          ? filters.minPrice.min
                          : filters.minPrice.min === ''
                            ? ''
                            : Number(filters.minPrice.min).toLocaleString()
                      }
                      onFocus={() => setIsMinPriceMinFocus(true)}
                      onBlur={() => setIsMinPriceMinFocus(false)}
                      onChange={(e) => handlePriceChange(e, 'minPrice', 'min')}
                    />
                    <span style={{ whiteSpace: 'nowrap' }}>만원</span>
                  </s.FilterInputWrapper>
                </div>

                <span style={{ padding: '26px 4px 0' }}>~</span>
                <div style={{ flex: 1 }}>
                  <s.MinMaxText>최대</s.MinMaxText>
                  <s.FilterInputWrapper>
                    <s.FilterInput
                      style={{ textAlign: 'right' }}
                      value={
                        isMinPriceMaxFocus
                          ? filters.minPrice.max
                          : filters.minPrice.max === ''
                            ? ''
                            : Number(filters.minPrice.max).toLocaleString()
                      }
                      onFocus={() => setIsMinPriceMaxFocus(true)}
                      onBlur={() => setIsMinPriceMaxFocus(false)}
                      onChange={(e) => handlePriceChange(e, 'minPrice', 'max')}
                    />
                    <span style={{ whiteSpace: 'nowrap' }}>만원</span>
                  </s.FilterInputWrapper>
                </div>
              </s.FilterRowContent>
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>매각기일</s.FilterLabel>
              <s.FilterRowContent>
                <s.DateInput
                  type="date"
                  onFocus={handleFocus}
                  placeholder=""
                  value={filters.saleDate.start}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      saleDate: {
                        ...filters.saleDate,
                        start: e.target.value,
                      },
                    });
                  }}
                />
                <span style={{ padding: '0 4px' }}>~</span>
                <s.DateInput
                  type="date"
                  onFocus={handleFocus}
                  placeholder=""
                  value={filters.saleDate.end}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      saleDate: {
                        ...filters.saleDate,
                        end: e.target.value,
                      },
                    });
                  }}
                />
              </s.FilterRowContent>
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>사용승인</s.FilterLabel>
              <s.FilterRowContent>
                <s.DateInput
                  type="date"
                  onFocus={handleFocus}
                  placeholder=""
                  value={filters.approvalDate.start}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      approvalDate: {
                        ...filters.approvalDate,
                        start: e.target.value,
                      },
                    });
                  }}
                />
                <span style={{ padding: '0 4px' }}>~</span>
                <s.DateInput
                  type="date"
                  onFocus={handleFocus}
                  placeholder=""
                  value={filters.approvalDate.end}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      approvalDate: {
                        ...filters.approvalDate,
                        end: e.target.value,
                      },
                    });
                  }}
                />
              </s.FilterRowContent>
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>
                <span>건물면적</span>
                <UnitSwitch unit={unit} setUnit={setUnit} />
              </s.FilterLabel>
              <s.FilterRowContent>
                <s.FilterInputWrapper>
                  <s.FilterInput
                    style={{ textAlign: 'right' }}
                    value={
                      isMinBuildingAreaFocus
                        ? filters.buildingArea.min
                        : filters.buildingArea.min === ''
                          ? ''
                          : unit === '평'
                            ? Number(filters.buildingArea.min).toLocaleString()
                            : (
                                Number(filters.buildingArea.min) * 3.30579
                              ).toLocaleString()
                    }
                    onFocus={() => setIsMinBuildingAreaFocus(true)}
                    onBlur={() => setIsMinBuildingAreaFocus(false)}
                    onChange={(e) => {
                      handlePriceChange(e, 'buildingArea', 'min');
                    }}
                  />
                  <span style={{ whiteSpace: 'nowrap' }}>
                    {unit === '평' ? '평' : '㎡'}
                  </span>
                </s.FilterInputWrapper>

                <span style={{ padding: '0 4px' }}>~</span>
                <s.FilterInputWrapper>
                  <s.FilterInput
                    style={{ textAlign: 'right' }}
                    value={
                      isMaxBuildingAreaFocus
                        ? filters.buildingArea.max
                        : filters.buildingArea.max === ''
                          ? ''
                          : unit === '평'
                            ? Number(filters.buildingArea.max).toLocaleString()
                            : (
                                Number(filters.buildingArea.max) * 3.30579
                              ).toLocaleString()
                    }
                    onFocus={() => setIsMaxBuildingAreaFocus(true)}
                    onBlur={() => setIsMaxBuildingAreaFocus(false)}
                    onChange={(e) => {
                      handlePriceChange(e, 'buildingArea', 'max');
                    }}
                  />
                  <span style={{ whiteSpace: 'nowrap' }}>
                    {unit === '평' ? '평' : '㎡'}
                  </span>
                </s.FilterInputWrapper>
              </s.FilterRowContent>
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>
                <span>토지면적</span>
                <UnitSwitch unit={unit1} setUnit={setUnit1} />
              </s.FilterLabel>
              <s.FilterRowContent>
                <s.FilterInputWrapper>
                  <s.FilterInput
                    style={{ textAlign: 'right' }}
                    value={
                      isMinLandAreaFocus
                        ? filters.landArea.min
                        : filters.landArea.min === ''
                          ? ''
                          : unit1 === '평'
                            ? Number(filters.landArea.min).toLocaleString()
                            : (
                                Number(filters.landArea.min) * 3.30579
                              ).toLocaleString()
                    }
                    onFocus={() => setIsMinLandAreaFocus(true)}
                    onBlur={() => setIsMinLandAreaFocus(false)}
                    onChange={(e) => {
                      handlePriceChange(e, 'landArea', 'min');
                    }}
                  />
                  <span style={{ whiteSpace: 'nowrap' }}>
                    {unit1 === '평' ? '평' : '㎡'}
                  </span>
                </s.FilterInputWrapper>
                <span style={{ padding: '0 4px' }}>~</span>
                <s.FilterInputWrapper>
                  <s.FilterInput
                    style={{ textAlign: 'right' }}
                    value={
                      isMaxLandAreaFocus
                        ? filters.landArea.max
                        : filters.landArea.max === ''
                          ? ''
                          : unit1 === '평'
                            ? Number(filters.landArea.max).toLocaleString()
                            : (
                                Number(filters.landArea.max) * 3.30579
                              ).toLocaleString()
                    }
                    onFocus={() => setIsMaxLandAreaFocus(true)}
                    onBlur={() => setIsMaxLandAreaFocus(false)}
                    onChange={(e) => {
                      handlePriceChange(e, 'landArea', 'max');
                    }}
                  />
                  <span style={{ whiteSpace: 'nowrap' }}>
                    {unit1 === '평' ? '평' : '㎡'}
                  </span>
                </s.FilterInputWrapper>
              </s.FilterRowContent>
            </s.FilterRow>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <s.FilterRow>
                <s.FilterLabel>유찰횟수</s.FilterLabel>
                <s.FilterRowContent>
                  <div style={{ flex: 1 }}>
                    <Select
                      options={BidStatusList}
                      styles={{
                        ...customStyles,
                        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                      }}
                      placeholder="선택"
                      value={
                        filters.bidno === ''
                          ? null
                          : {
                              label: filters.bidno,
                              value: filters.bidno,
                            }
                      }
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          const selected = selectedOption.label;
                          setFilters({ ...filters, bidno: selected });
                        }
                      }}
                    />
                  </div>
                </s.FilterRowContent>
              </s.FilterRow>
              <s.FilterRow>
                <s.FilterLabel>진행단계</s.FilterLabel>
                <s.FilterRowContent>
                  <div style={{ flex: 1 }}>
                    <Select
                      options={
                        filters.type === 'p'
                          ? PTypeProgressStatusList
                          : ProgressStatusList
                      }
                      styles={{
                        ...customStyles,
                        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      placeholder="선택"
                      value={
                        filters.progressStatus === ''
                          ? null
                          : {
                              label: filters.progressStatus,
                              value: filters.progressStatus,
                            }
                      }
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          setFilters({
                            ...filters,
                            progressStatus: selectedOption.label,
                          });
                        }
                      }}
                    />
                  </div>
                </s.FilterRowContent>
              </s.FilterRow>
            </div>
            <s.FilterRow>
              <s.FilterLabel>용도지역</s.FilterLabel>
              <s.FilterRowContent>
                <div style={{ flex: 1 }}>
                  <Select
                    options={UseAreaList}
                    styles={{
                      ...customStyles,
                      control: (provided: any) => ({
                        ...customStyles.control(provided),
                      }),
                    }}
                    placeholder="선택"
                    value={
                      filters.useArea.length > 0
                        ? {
                            label: filters.useArea[0],
                            value: filters.useArea[0],
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFilters({
                          ...filters,
                          multiUseArea: [],
                          useArea: [selectedOption.label],
                        });
                      }
                    }}
                    isDisabled={showUsageArea}
                  />
                </div>
                {showUsageArea ? (
                  <s.PlusButton
                    style={{ backgroundColor: '#0052BD' }}
                    onClick={() => setShowUsageArea(false)}
                  >
                    <span>단일선택</span>
                    <img src="/assets/images/close/close-white.svg" alt="" />
                  </s.PlusButton>
                ) : (
                  <s.PlusButton onClick={() => setShowUsageArea(true)}>
                    <span>복수선택</span>
                    <img src="/assets/images/icon/plus-white.svg" alt="" />
                  </s.PlusButton>
                )}
              </s.FilterRowContent>
              {showUsageArea && (
                <UseArea filters={filters} setFilters={setFilters} />
              )}
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>특수조건</s.FilterLabel>
              <s.FilterRowContent>
                <div style={{ flex: 1 }}>
                  <Select
                    options={SpecialConditionList}
                    styles={{
                      ...customStyles,
                      control: (provided: any) => ({
                        ...customStyles.control(provided),
                      }),
                    }}
                    placeholder="선택"
                    value={
                      filters.specialItemCondition.length > 0
                        ? {
                            label: filters.specialItemCondition[0],
                            value: filters.specialItemCondition[0],
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFilters({
                          ...filters,
                          multiSpecialItemCondition: [],
                          specialItemCondition: [selectedOption.label],
                        });
                      }
                    }}
                    isDisabled={showSpecialCondition}
                  />
                </div>
                {showSpecialCondition ? (
                  <s.PlusButton
                    style={{ backgroundColor: '#0052BD' }}
                    onClick={() => setShowSpecialCondition(false)}
                  >
                    <span>단일선택</span>
                    <img src="/assets/images/close/close-white.svg" alt="" />
                  </s.PlusButton>
                ) : (
                  <s.PlusButton onClick={() => setShowSpecialCondition(true)}>
                    <span>복수선택</span>
                    <img src="/assets/images/icon/plus-white.svg" alt="" />
                  </s.PlusButton>
                )}
              </s.FilterRowContent>
              {showSpecialCondition && (
                <SpecailCondition filters={filters} setFilters={setFilters} />
              )}
            </s.FilterRow>
            <s.FilterRow>
              <s.FilterLabel>NPL보유사</s.FilterLabel>
              <s.FilterRowContent>
                <div style={{ flex: 1 }}>
                  <Select
                    options={NplHolderList}
                    styles={{
                      ...customStyles,
                      control: (provided: any) => ({
                        ...customStyles.control(provided),
                      }),
                    }}
                    placeholder="선택"
                    value={
                      filters.holdingCompany.length > 0
                        ? {
                            label: filters.holdingCompany[0],
                            value: filters.holdingCompany[0],
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFilters({
                          ...filters,
                          multiHoldingCompany: [],
                          holdingCompany: [selectedOption.label],
                        });
                      }
                    }}
                    isDisabled={showHoldingCompany}
                  />
                </div>
                {showHoldingCompany ? (
                  <s.PlusButton
                    style={{ backgroundColor: '#0052BD' }}
                    onClick={() => setShowHoldingCompany(false)}
                  >
                    <span>단일선택</span>
                    <img src="/assets/images/close/close-white.svg" alt="" />
                  </s.PlusButton>
                ) : (
                  <s.PlusButton onClick={() => setShowHoldingCompany(true)}>
                    <span>복수선택</span>
                    <img src="/assets/images/icon/plus-white.svg" alt="" />
                  </s.PlusButton>
                )}
              </s.FilterRowContent>
              {showHoldingCompany && (
                <HoldingCompany filters={filters} setFilters={setFilters} />
              )}
            </s.FilterRow>
          </s.FilterOptionBox>
          <s.ButtonBox>
            <s.ResetButton onClick={handleReSet}>
              <img src="/assets/images/icon/reset.svg" alt="" />
              <span>초기화</span>
            </s.ResetButton>
            <s.ApplyButton
              onClick={() => {
                if (!isLogin()) {
                  modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                  return;
                }
                if (isOnlyProgressStatusChangedToAll()) {
                  window.alert(
                    `진행단계 '전체'를 선택할 경우, 추가 조건 입력이 필요합니다.\n검색 조건을 추가해주세요.`,
                  );
                  return;
                }
                getList(offset, sort, filters);
              }}
            >
              검색
            </s.ApplyButton>
          </s.ButtonBox>
        </s.FilterBox>
        <List
          data={data}
          totalCount={total}
          sort={sort}
          setSort={setSort}
          setOffset={setOffset}
          filters={filters}
          limit={limit}
          loading={loading}
          page="search"
          setSelectedIdx={setSelectedIdx}
          setShowLikeModal={setShowLikeModal}
          setMode={setMode}
          setSelectedItem={setSelectedItem}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          getList={getList}
        />
        {showLikeModal && (
          <AddInterestItemModal
            setShowLikeModal={setShowLikeModal}
            selectedIdx={selectedIdx}
            mode={mode}
            selectedItem={selectedItem}
            getList={getList}
            offset={offset}
            sort={sort}
            filters={filters}
            setActiveItem={setActiveItem}
          />
        )}
        <Footer />
      </s.Container>
    </Container>
  );
};

export default NplSearch;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;

const filteredValues = (data: any) => {
  const newArray = data
    .map((name: string) => {
      const company = totalHoldinsCompany.find(
        (company: any) => company.name === name,
      );
      return company ? company.value : undefined;
    })
    .filter(Boolean);

  return newArray.join(',');
};
